import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { cn } from '@/lib/utils'
import { useInView } from '@/hooks/use-in-view'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
}

const Reveal: FC<RevealProps> = ({ children, className, delay = 0 }): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)
    const inView = useInView(ref, { threshold: 0.12 })

    return (
        <div
            ref={ref}
            style={{ transitionDelay: inView ? `${delay}ms` : '0ms' }}
            className={cn(
                'transition duration-700 ease-out motion-reduce:transition-none',
                inView
                    ? 'translate-y-0 opacity-100'
                    : 'translate-y-8 opacity-0 motion-reduce:translate-y-0 motion-reduce:opacity-100',
                className
            )}
        >
            {children}
        </div>
    )
}

export default Reveal
